module.exports = __webpack_public_path__ + "static/img/C4D0009.56be3bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0009.jpg
// module id = O8Yw
// module chunks = 0